import { render } from "./PromoCodeYogaView.vue?vue&type=template&id=4c20bfbf&scoped=true"
import script from "./PromoCodeYogaView.vue?vue&type=script&lang=js"
export * from "./PromoCodeYogaView.vue?vue&type=script&lang=js"

import "./PromoCodeYogaView.vue?vue&type=style&index=0&id=4c20bfbf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c20bfbf"]])

export default __exports__